export let STYLE = [
  'alignContent',
  'alignItems',
  'alignSelf',
  'animation',
  'appRegion',
  'background',
  'backgroundColor',
  'backgroundImage',
  'backgroundPosition',
  'backgroundRepeat',
  'backgroundSize',
  'backdropFilter',
  'borderBottomColor',
  'borderBottomLeftRadius',
  'borderBottomRightRadius',
  'borderBottomStyle',
  'borderBottomWidth',
  'borderColor',
  'borderLeftColor',
  'borderLeftStyle',
  'borderLeftWidth',
  'borderRightColor',
  'borderRightStyle',
  'borderRightWidth',
  'borderStyle',
  'borderTopColor',
  'borderTopLeftRadius',
  'borderTopRightRadius',
  'borderTopStyle',
  'borderTopWidth',
  'borderWidth',
  'bottom',
  'clipPath',
  'color',
  'cursor',
  'display',
  'direction',
  'fill',
  'filter',
  'flexGrow',
  'flexBasis',
  'flexDirection',
  'flexFlow',
  'flexShrink',
  'flexWrap',
  'fontFamily',
  'fontSize',
  'fontStyle',
  'fontWeight',
  'height',
  'hyphens',
  'justifyContent',
  'left',
  'letterSpacing',
  'lineHeight',
  'marginBottom',
  'marginLeft',
  'marginRight',
  'marginTop',
  'maxHeight',
  'maxWidth',
  'minHeight',
  'minWidth',
  'opacity',
  'outlineColor',
  'outlineOffset',
  'outlineStyle',
  'outlineWidth',
  'overflowWrap',
  'overflowX',
  'overflowY',
  'paddingBottom',
  'paddingLeft',
  'paddingRight',
  'paddingTop',
  'pointerEvents',
  'position',
  'resize',
  'right',
  'shadowColor',
  'shadowOffsetX',
  'shadowOffsetY',
  'shadowBlur',
  'shadowSpread',
  'shadowInset',
  'stroke',
  'strokeDashoffset',
  'strokeDasharray',
  'textAlign',
  'textDecoration',
  'textOverflow',
  'textJustify',
  'textTransform',
  'top',
  'translateX',
  'translateY',
  'scale',
  'scaleX',
  'scaleY',
  'rotate',
  'rotateX',
  'rotateY',
  'transformOriginX',
  'transformOriginY',
  'transition',
  'unicodeBidi',
  'userSelect',
  'whiteSpace',
  'width',
  'wordBreak',
  'wordSpacing',
  'wordWrap',
  'zIndex',
  // '@fontFace',
  // '@keyframes',
  // '@media',
  // 'background',
  // 'backgroundAttachment',
  // 'backgroundBlend-mode',
  'backgroundClip',
  // 'backgroundOrigin',
  // 'backgroundPosition',
  // 'backgroundRepeat',
  // 'border',
  // 'borderBottom',
  // 'borderCollapse',
  // 'borderImage',
  // 'borderImageOutset',
  // 'borderImageRepeat',
  // 'borderImageSlice',
  // 'borderImageSource',
  // 'borderImageWidth',
  // 'borderLeft',
  // 'borderRadius',
  // 'borderRight',
  // 'borderSpacing',
  // 'borderTop',
  // 'boxShadow',
  // 'boxSizing',
  // 'captionSide',
  // 'clear',
  // 'clip',
  // 'column-gap',
  // 'columnCount',
  // 'columnFill',
  // 'columnRule',
  // 'columnRuleColor',
  // 'columnRuleStyle',
  // 'columnRuleWidth',
  // 'columnSpan',
  // 'columnWidth',
  // 'columns',
  // 'content',
  // 'counterIncrement',
  // 'counterReset',
  // 'direction',
  // 'display',
  // 'emptyCells',
  // 'float',
  // 'font',
  // 'font-variant',
  // 'fontSizeAdjust',
  // 'fontStretch',
  // 'hangingPunctuation',
  // 'listStyle',
  // 'listStyleImage',
  // 'listStylePosition',
  // 'listStyleType',
  // 'margin',
  // 'nav-up',
  // 'navDown',
  // 'navIndex',
  // 'navLeft',
  // 'navRight',
  'order',
  // 'outline',
  // 'overflow',
  // 'padding',
  // 'pageBreakAfter',
  // 'pageBreakBefore',
  // 'pageBreakInside',
  'perspective',
  'perspectiveOrigin',
  // 'quotes',
  // 'tabSize',
  // 'tableLayout',
  // 'textAlignLast',
  'textDecorationColor',
  'textDecorationLine',
  'textDecorationStyle',
  // 'textIndent',
  // 'textShadow',
  // 'transformStyle',
  // 'transitionDelay',
  // 'transitionDuration',
  // 'transitionProperty',
  // 'transitionTimingFunction',
  // 'unicodeBidi',
  // 'verticalAlign',
  'visibility',
  'willChange',
]
export let ROWSTYLE = [
  'rowBackgroundColor',
  'rowBackgroundColorAlternate',
  'rowColor',
  'rowColorAlternate',
]

export let isStyle = (name) => STYLE.includes(name)
export let isRowStyle = (name) => ROWSTYLE.includes(name)
